import { render } from "./ValidationHistoryContainer.vue?vue&type=template&id=1f2a5be9"
import script from "./ValidationHistoryContainer.vue?vue&type=script&lang=js"
export * from "./ValidationHistoryContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__